import animation from '../../assets/loading/dyno.json';
import {Player} from '@lottiefiles/react-lottie-player';
import { Box } from '@mui/material';

const DynoLoader = ({justifyContent= "center", alignItems="center", height = "100vh", width = "100vw", customLoader, customLoaderWidth, customLoaderHeight}) => {
  return (
    <Box sx={{
      display: "flex",
      justifyContent,
      alignItems,
      height,
      width
    }}>
      <Player
        src={customLoader? customLoader : animation}
        style={{ width: customLoaderWidth? customLoaderWidth : "250px", height: customLoaderHeight? customLoaderHeight : "250px" }}
        loop
        autoplay
      />
    </Box>
  )
};

export default DynoLoader;
